module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loadError":"Occurred while the file was loading"},"es":{"loadError":"Ocurrió mientras se cargaba el archivo"}}')
  delete Component.options._Ctor
}
